export const concatArray = arr =>
  arr?.length === 1 ? arr[0] : arr?.slice(0, -1).join(', ') + ' y ' + arr?.slice(-1)
